export default "__VITE_ASSET__DO3hwxSU__"